import { render, staticRenderFns } from "./SupportActivity.vue?vue&type=template&id=db4a76a6&scoped=true&"
import script from "./SupportActivity.vue?vue&type=script&lang=js&"
export * from "./SupportActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4a76a6",
  null
  
)

export default component.exports